import { nextIterationAsync } from "./_nextIterationAsync.js";
export const countAsync = async (source, predicate) => {
    const data = nextIterationAsync(source, predicate);
    let countPromise;
    switch (data.type) {
        case 1:
            countPromise = Promise.all(data.generator());
            break;
        case 2:
            countPromise = Promise.all(await data.generator());
            break;
    }
    let totalCount = 0;
    for (const value of await countPromise) {
        if (value) {
            totalCount++;
        }
    }
    return totalCount;
};
